import { Stack } from '@fluentui/react';

import AccountSection from './AccountSection';
import FormButtons from './FormButtons';
import PaymentsList from './PaymentList';
import ProductsList from './ProductList';
import { FormContentBox } from './utils';

export default () => {
  return (
    <Stack tokens={{ childrenGap: 20 }}>
      <FormContentBox title="Müşteri Bilgileri">
        <AccountSection />
      </FormContentBox>
      <FormContentBox title="Ürün Listesi">
        <ProductsList />
      </FormContentBox>
      <FormContentBox title="Ödeme Listesi">
        <PaymentsList />
      </FormContentBox>
      <FormButtons />
    </Stack>
  );
};
